/**
 *
 * Asynchronously loads the component for SectionPage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
